import React, {
  Component,
  Suspense,
  useState,
  useEffect,
  useContext,
} from "react";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import { Icon, Row, Col, Button, Select } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActivated } from "../redux/slices/loginSlice";
import { resetStateProperties } from "../redux/slices/propertiesSlice";
import { resetStateRooms } from "../redux/slices/roomsSlice";
import { resetStateItems } from "../redux/slices/itemsSlice";
import { Link, withRouter } from "react-router-dom";
import { isUserAuthenticated } from "../helpers/authUtils";
import profilePic from "../assets/images/users/user-1.jpg";
import userProfile from "../assets/images/UserProfile.png";
import defaultProfilePicture from "../assets/images/newdefaultprofilepicture.png";

import logo from "../assets/images/asset-planet-background.png";
import bell from "../assets/images/bell.png";
import time from "../assets/images/time.png";
import logoutimg from "../assets/images/logout.png";
import bright from "../assets/images/bright.png";
import DEATH_API from "../apis/death.api";
import { isMobile } from "react-device-detect";
import { MODULE_API } from "../apis";
import { setCollection } from "../redux/inventory/actions";
import backButton from "../assets/SVGs/backbutton.png";
import homeButton from "../assets/images/home11.png";
import { useTheme } from "../utils/ThemeContext.jsx";

// import assets from '../../assets/images/asset.png';

import ROLES from "constants/roles";
import Sidebar from "./Sidebar";
import SidebarProfile from "./SidebarProfile";
import AiChampion from "./newly-components/AiChampion";
import { ProgressContext } from "../utils/ProgressContext.jsx";
import PlaidSyncProgressLoader from "./PlaidSyncProgressLoader.js";
import { setAddClientButton } from "../redux/slices/financialAdvisorSlice.js";
import { GlobalLoaderContext } from "../utils/GlobalLoaderContext.js";
// code splitting and lazy loading
// https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52
const Topbar = React.lazy(() => import("./Topbar"));
const Navbar = React.lazy(() => import("./Navbar"));
const RightSidebar = React.lazy(() => import("./RightSidebar"));
const Footer = React.lazy(() => import("./Footer"));
const loading = () => <div className="text-center"></div>;
const { Option } = Select;

const RightSidebarContent = (props) => {
  return (
    <div className="user-box">
      <div className="user-img">
        <img
          src={profilePic}
          alt="user-img"
          title="Nik Patel"
          className="rounded-circle img-fluid"
        />
        <a href="/" className="user-edit">
          <i className="mdi mdi-pencil"></i>
        </a>
      </div>

      <h5>{props.user && <a href="/">{props.user.username}</a>}</h5>
      <p className="text-muted mb-0">
        <small>Founder</small>
      </p>
    </div>
  );
};

const BackButton = (props) => {
  const history = useHistory();
  function navigateBack() {
    const currentURL =
      history.location &&
      history.location.pathname &&
      history.location.pathname;
    const gobackLink = "/subscription";
    const redirectLink = "/dashboard";
    if (
      currentURL.startsWith(gobackLink) ||
      currentURL.startsWith("/delgateAccess")
    ) {
      console.log(
        `%c Go Back to ${redirectLink}`,
        "cursor: pointer; text-decoration: underline; color: blue;",
        () => history.goBack({ pathname: redirectLink })
      );
      history.push(redirectLink);
    } else {
      console.log(
        "%c Go Back",
        "cursor: pointer; text-decoration: underline; color: blue;",
        () => history.goBack()
      );
      history.goBack();
    }
    // history.goBack();
    // history.goBack();
  }
  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "#2A3DA3",
        width: "2rem",
        height: "2rem",
        borderRadius: "4px",
        padding: "2px",
        justifyContent: "center",
        cursor: "pointer",
        marginLeft: "5px",
        alignItems: "center",
      }}
      onClick={navigateBack}>
      <img
        height="100%"
        width="100%"
        src={homeButton}
        alt="asset planet back button"
      />
    </div>
  );
};

function ClientInfo() {
  const [state, setState] = useState();
  return (
    <div
      className="right-menu"
      style={{ rowGap: "0.6rem", display: "grid", zIndex: "2" }}>
      <div className="side-menu-block3">
        <span className="side-menu-title" style={{ textAlign: "center" }}>
          Change Client
        </span>
      </div>

      <div
        style={{
          display: "flex",
          columnGap: "0.2rem",
          alignItems: "center",
          textAlign: "justify",
        }}>
        <div className="side-menu-block3">
          <span className="side-menu-title">Frank Jones</span>
        </div>
        <Icon className="icon-organizer" type="right" />
      </div>

      <div className="side-menu-block3">
        <span className="side-menu-title" style={{ textAlign: "center" }}>
          Change Plan
        </span>
      </div>

      <div
        style={{
          display: "flex",
          columnGap: "0.2rem",
          alignItems: "center",
          textAlign: "justify",
        }}>
        <div className="side-menu-block3">
          <span className="side-menu-title">Plan One</span>
        </div>
        <Icon className="icon-organizer" type="right" />
      </div>

      <div className="side-menu-block3">
        <span className="side-menu-title">Recent Modules</span>
      </div>

      <div className="side-menu-block3">
        <span className="side-menu-title" style={{ textAlign: "center" }}>
          Inventory
        </span>
      </div>

      <div className="side-menu-block3">
        <span className="side-menu-title" style={{ textAlign: "center" }}>
          Divorce
        </span>
      </div>

      <div className="side-menu-block3">
        <span className="side-menu-title" style={{ textAlign: "center" }}>
          Budget
        </span>
      </div>
    </div>
  );
}

const PageLayout = (props) => {
  // console.log(props)
  const children = [props.children];
  const { theme } = useTheme();
  // this.toggleRightSidebar = this.toggleRightSidebar.bind(this);
  // this.toggleMenu = this.toggleMenu.bind(this);
  const { resetLoader } = useContext(GlobalLoaderContext);
  const [isMenuOpened, setisMenuOpened] = useState(true);
  const [modules, setmodules] = useState([]);
  const dispatch = useDispatch();

  const [accessableUsers, setaccessableUsers] = useState([]);
  const [profileDetails, setProfileDetails] = useState(null);
  const [profileChange, setProfileChange] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);

  const [isDropdownOpen, setisDropdownOpen] = useState(false);

  const [isDropdownOpen1, setisDropdownOpen1] = useState(false);
  const [wrapperClass, setwrapperClass] = useState("");
  const [defaultValueName, setDefaultValueName] = useState("Me");

  const { loadingProgress, progress } = useContext(ProgressContext);

  const [accessId, setAccessId] = useState("");
  const activated = useSelector(
    (state) => state.rootReducer.loginUser.activated
  );

  const deleUsers = useSelector(
    (state) => state.rootReducer.financialAdvisor.delegateUsers
  );

  let wrapperClassName = "";
  let userRole = null;
  let users = null;
  useEffect(() => {
    let isAuthTokenValid = true;

    // if (isMobile) {
    //   // this.setState({ isMenuOpened: !this.state.isMenuOpened });
    //   setisMenuOpened(!isMenuOpened);
    // }

    if (isMenuOpened) {
      setwrapperClass("left-sidebar--opened");
    } else {
      setwrapperClass("left-sidebar--collapsed");
    }

    isAuthTokenValid = true;

    if (
      [
        "Login",
        "Logout",
        "Forget Password",
        "Register",
        "Confirm",
        "Signup",
        "Otp",
        "TrusteeLogin",
        "Accept Invitation",
        "Payment",
        "Free Trial",
        "Profile Questionnaire",
        "Select Dashboard",
        "Page Not Found",
        // "Client and Plan"
      ].some((item) => item == props.route.name)
    ) {
      setwrapperClass("left-side--hidden");
      // wrapperClassName = wrapperClassName + " left-side--hidden";
    }
  });

  const [userRoles, setUserRoles] = useState("");
  const [userss, setUserss] = useState("");
  const history = useHistory();

  useEffect(() => {
    if (
      !(props.route.name === "Login") &&
      !(props.route.name === "Otp") &&
      !(props.route.name === "Logout") &&
      !(props.route.name === "Forget Password") &&
      !(props.route.name === "Confirm") &&
      !(props.route.name === "Signup") &&
      !(props.route.name === "TrusteeLogin") &&
      !(props.route.name === "Accept Invitation") &&
      !(props.route.name === "Payment")
    ) {
      getProfilePicture();
    }
  }, [profileChange]);
  useEffect(() => {
    if (
      !(props.route.name === "Login") &&
      !(props.route.name === "Otp") &&
      !(props.route.name === "Logout") &&
      !(props.route.name === "Forget Password") &&
      !(props.route.name === "Confirm") &&
      !(props.route.name === "Signup") &&
      !(props.route.name === "TrusteeLogin") &&
      !(props.route.name === "Accept Invitation") &&
      !(props.route.name === "Payment")
    ) {
      getUserRole();
    }
  }, []);
const inactiveRoles = ["inActive financial adviser client", "inActive Financial Advisor", "inactiveClient"]
  const getUserRole = async () => {
    try {
      let outputObj = {};
      let data = await DEATH_API.getUpdatedRole();
      if (data && data.data) {
        let loginRole;
        if (data.data.roles) {
          loginRole = data.data.roles;
        }
        let recursive = (obj, name) => {
          for (let key in obj) {
            if (typeof obj[key] == "object") {
              recursive(obj[key], name + "_" + key);
            } else {
              outputObj[key] = obj[key];
            }
          }
        };
        recursive(loginRole, "loginRole");
        if (
          outputObj &&
          outputObj.name &&
          inactiveRoles.includes(outputObj.name)
          // outputObj.name === "inactiveClient" 
        ) {
          localStorage.setItem("role", JSON.stringify(outputObj.name));
          history.push("/payment");
        }
      }
      if (data && data.data && data.data.setting) {
        localStorage.setItem("setting",JSON.stringify(data.data.setting))
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getProfilePicture = () => {
    // console.log("calling function profile")
    setProfilePicture(
      localStorage.getItem("profile") && localStorage.getItem("profile")
    );
  };
  useEffect(() => {
    // Perform localStorage action
    // setAccessId(localStorage.getItem("accessId") && localStorage.getItem("accessId"))
    // getProfileDetails();
    let userRole1 = "";
    let users1 = "";
    try {
      userRole1 =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role") || null);
      users1 =
        localStorage.getItem("delegateUsers") != "undefined" &&
        JSON.parse(localStorage.getItem("delegateUsers") || null);
      setUserRoles(userRole1);
      setUserss(users1);
      const defaultValue = users1 && users1.filter(function (item) {
        var accessId = localStorage.getItem("accessId");
        return (item.id && item.id == accessId) || (item.client && item.client.id && item.client.id == accessId);
      });
      // console.log("defaultValue", defaultValue[0])
      if (defaultValue && defaultValue[0] && (defaultValue[0].name || defaultValue[0].client.name)) {
        setDefaultValueName(defaultValue[0].name);
        setDefaultValueName(defaultValue[0].name ? defaultValue[0].name : defaultValue[0].client.name);
      }
    } catch (error) {
      console.log("error", error);
    }
    // console.log("props.route.name", props.route.name)
    if (
      props.route.name !== "Login" &&
      props.route.name !== "Otp" &&
      props.route.name !== "Logout" &&
      props.route.name !== "Forget Password" &&
      props.route.name !== "Confirm" &&
      props.route.name !== "Signup" &&
      props.route.name !== "TrusteeLogin" &&
      props.route.name !== "Accept Invitation" &&
      props.route.name !== "Payment" &&
      props.route.name !== "Free Trial"
    ) {
      if (!userRole1 || userRole1 == null) {
        // console.log("nullllllll");
        localStorage.setItem("userLoginToken", "");
        history.push("/login");
      }
      // getProfileDetails();
    } else {
      setUserRoles(userRole1);
      setUserss(users1);
      // getProfileDetails();
      // const result = users1.filter((user) => user.id == localStorage.getItem("accessId"))
      // console.log("result", result)
    }
    if (isMenuOpened) {
      setwrapperClass("left-sidebar--opened");
    } else {
      setwrapperClass("left-sidebar--collapsed");
    }
  }, []);

  useEffect(() => {
    // Perform localStorage action
    let userRole1 = "";
    let users1 = "";
    // console.log("accessId", accessId)
    try {
      userRole1 =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role") || null);
      users1 =
        localStorage.getItem("delegateUsers") != "undefined" &&
        JSON.parse(localStorage.getItem("delegateUsers") || null);
      setUserRoles(userRole1);
      setUserss(users1);
      if (localStorage.getItem("accessId")) {
        // console.log("here in access id")
        const defaultValue = users1 && users1.filter(function (item) {
          var accessId = localStorage.getItem("accessId");
          return (
            (item.id && item.id == accessId) ||
            (item.client && item.client.id && item.client.id == accessId)
          );
        });

//         console.log("defaultValue2222", defaultValue[0])
        if(defaultValue && defaultValue[0]){
          setDefaultValueName(defaultValue[0].name ? defaultValue[0].name : defaultValue[0].client.name);
        }

      } else {
        setDefaultValueName("Me");
        // console.log("here in else me")
      }
    } catch (error) {
      console.log("error", error);
    }
  }, [activated, accessId]);

  const get = async (name) => {
    try {
      const { dispatch } = props;
      let attributes = await MODULE_API.fetchAttributes(`${name}_item`);
      if (attributes) {
        dispatch(setCollection(attributes));
      }
    } catch (error) {
      console.log("e ", error);
    }
  };
  const getProfileDetails = async () => {
    try {
      //   setFormData(null);
      // setLoading(true);
      let data = await DEATH_API.getProfileData();
      // setLoading(false);
      if (data && data.data) {
        data.data.phoneNumber = `${data.data.countryCode} ${data.data.phoneNumber}`;
        setProfileDetails(data.data);
      }

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  };
  const signOut = (e) => {
    // e.preventDefault();
    dispatch(resetStateProperties());
    dispatch(resetStateRooms());
    dispatch(resetStateItems());
    resetLoader();
    localStorage.removeItem("userLoginToken");
    localStorage.removeItem("role");
    localStorage.removeItem("delegateUsers");
    localStorage.removeItem("otp");
    localStorage.removeItem("User");
    localStorage.removeItem("fields");
    localStorage.removeItem("accessId");
    localStorage.removeItem("duplicateRole");
    localStorage.removeItem("profile");
    localStorage.removeItem("permissionState");
    localStorage.removeItem("userName");
    localStorage.clear();
  };

  /**
   * toggle Menu
   */
  const toggleMenu = (e) => {
    e.preventDefault();
    // this.setState({ isMenuOpened: !this.state.isMenuOpened });
    setisMenuOpened(!isMenuOpened);
  };

  /**
   * Toggle right side bar
   */
  const toggleRightSidebar = () => {
    document.body.classList.toggle("right-bar-enabled");
  };
  const isUserData = () => {
    if (!userRole || !users) {
      const history = useHistory();
      history.push("/login");
      return false;
    }
    return true;
  };
  const noSidebarRoutes = [
    "Login",
    "TrusteeLogin",
    "Otp",
    "Signup",
    "Forget Password",
    "Free Trial",
    "Profile Questionnaire",
    "Accept Invitation",
    "Page Not Found",
  ];
  const shouldHaveNoMargin = noSidebarRoutes.includes(props.route.name);

  const duplicateRole = localStorage.getItem("duplicateRole") != "undefined" &&  JSON.parse(localStorage.getItem("duplicateRole") || 'null');
  const role = localStorage.getItem("role") != "undefined" &&  JSON.parse(localStorage.getItem("role") || 'null');
  return (
    <React.Fragment>
      {
        <React.Fragment>
          <div id="wrapper" className={wrapperClass}>
            <div
              style={{
                position: "fixed",
                top: 0,
                right: 0,
                zIndex: 9,
                left: 0,
                height: "80px",
                backgroundColor: theme === "dark" ? "#232323" : "#F4F7FE",
              }}>
              <Row
                className={`content-page ${shouldHaveNoMargin ? "no-margin-important" : ""}`}
                style={{
                  minHeight: "80px",
                  padding: isMobile ? "0 12px" : "0 20px",
                  backgroundColor: theme === "dark" ? "#232323" : "white",
                }}
                type="flex"
                align="middle"
                justify="center">
                <Col xs={24}>
                  <Row type="flex" align="middle">
                    {props.route.name === "Login" ? (
                      <Col xs={8}>
                        <React.Fragment></React.Fragment>
                      </Col>
                    ) : (
                      <Col xs={8}>
                        <BackButton />
                      </Col>
                    )}
                    <Col xs={8}>
                      <Row type="flex" justify="center">
                        {props.route.name === "Login" ||
                        props.route.name === "TrusteeLogin" ||
                        props.route.name === "Otp" ||
                        props.route.name === "Signup" ||
                        props.route.name === "Forget Password" ? (
                          <img
                            src={logo}
                            height={isMobile ? "30px" : "40px"}
                            alt="asset-planet-logo"
                          />
                        ) : (
                          <React.Fragment>
                            <div
                              style={{
                                fontSize: "18px",
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                color: theme === "dark" ? "white" : "black",
                                textAlign: "center",
                              }}>
                              {(props.route &&
                                props.route.name === "DeathDashboard" &&
                                "When I Die") ||
                                (props.route &&
                                  props.route.name === "DemoDeath" &&
                                  "Death (When I Die)") ||
                                (props.route &&
                                  (props.route.name === "Asset" ||
                                    props.route.name === "Asset New" ||
                                    props.route.name === "Airplane Listing" ||
                                    props.route.name === "List") &&
                                  "Assets") ||
                                (props.route &&
                                  props.route.name === "plaid" &&
                                  "Link Bank") ||
                                (props.route &&
                                  props.route.name === "feedback" &&
                                  "Feedback") ||
                                (props.route && props.route.name)}
                            </div>
                          </React.Fragment>
                        )}
                      </Row>
                    </Col>
                    {props.route.name === "Login" ||
                    props.route.name === "TrusteeLogin" ||
                    props.route.name === "Otp" ||
                    props.route.name === "Signup" ||
                    props.route.name === "Forget Password" ? (
                      <Col xs={8}>
                        <React.Fragment></React.Fragment>
                      </Col>
                    ) : (
                      <Col xs={8}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            backgroundColor:
                              theme === "dark" ? "#232323" : "#ffffff",
                            alignItems: "center",
                          }}>
                          {userRoles && userss && userss.length > 0 && (
                            // (userRoles == "trustee" || userRoles == "protrustee") &&
                            <div
                              className="selectBox"
                              style={{ marginLeft: isMobile ?"8rem":"0" }}>
                              <Select
                                style={{
                                  width: "10rem",
                                  // marginLeft: "auto",
                                  // float: "right",
                                }}
                                // defaultValue={defaultValueName}
                                showSearch
                                value={
                                  (["activeClient", "Financial Advisor", "Active Financial Advisor"].includes(duplicateRole) ||
                                    ["activeClient", "Financial Advisor","Active Financial Advisor"].includes(role))
                                    ? defaultValueName
                                    : defaultValueName === "Me"
                                    ? ""
                                    : defaultValueName
                                }
                                // value={localStorage.getItem("accessId")}
                                placeholder="-Select Client-"
                                onChange={(val, id) => {
                                  try {
                                    (async () => {
                                      // console.log("value", id)
                                      if (val === "Me") {
                                        setDefaultValueName("Me");
                                        if (localStorage.getItem("accessId")) {
                                          localStorage.removeItem("accessId");
                                          localStorage.removeItem("financialAccess");
                                        }
                                        if (
                                          localStorage.getItem("duplicateRole")
                                        ) {
                                          localStorage.setItem(
                                            "role",
                                            localStorage.getItem(
                                              "duplicateRole"
                                            )
                                          );
                                        }
                                        dispatch(setActivated(!activated));
                                        localStorage.removeItem("duplicateRole");
                                        if (
                                          props.route.name ===
                                            "DeathDashboard" ||
                                          props.route.name === "DemoDeath"
                                        ) {
                                          window.location.reload();
                                        }
                                      } else {
                                        const findUserRole =
                                          userss &&
                                          userss.filter(
                                            (item) => item.id || item.client && item.client.id == id.props.value
                                          );
                                      console.log("findUserRole",findUserRole[0])
                                        if (
                                          !localStorage.getItem("duplicateRole")
                                        ) {
                                          localStorage.setItem(
                                            "duplicateRole",
                                            localStorage.getItem("role")
                                          );
                                        }
                                        if (
                                          findUserRole &&
                                          findUserRole[0] &&
                                          findUserRole[0].trusteeUser &&
                                          findUserRole[0].trusteeUser[0]
                                        ) {
                                          localStorage.setItem(
                                            "role",
                                            JSON.stringify(
                                              findUserRole[0].trusteeUser[0]
                                                .role.name
                                            )
                                          );
                                        }
                                        console.log("duplicateRole",role)
                                        const userRoles = ["Financial Advisor", "Active Financial Advisor"]
                                        if(userRoles.includes(role)){
                                           localStorage.setItem("role",JSON.stringify("Financial Advisor Client"));
                                        }

                                        // localStorage.setItem("role", JSON.stringify(findUserRole[0].role.name))

                                        dispatch(setActivated(!activated));
                                        setAccessId(val);
                                        localStorage.setItem("accessId", val);
                                        if (
                                          props.route.name ===
                                            "DeathDashboard" ||
                                          props.route.name === "DemoDeath"
                                        ) {
                                          window.location.reload();
                                        }
                                      }
                                    })();
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}>
                                {deleUsers &&
                                  deleUsers.map((item, index) => (
                                    <Option key={index} value={item.id || item.client && item.client.id}>
                                      {item.name || item.client && item.client.name}
                                    </Option>
                                  ))}
                                  {(["activeClient", "Financial Advisor", "Active Financial Advisor"].includes(duplicateRole) ||
                                    ["activeClient", "Financial Advisor", "Active Financial Advisor"].includes(role)) && (
                                  <Option value={"Me"}>{"Me"}</Option>
                                  )}
                              </Select>
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              alignItems: "center",
                            }}>
                            <div
                              style={{
                                display: "flex",
                                gap:  isMobile ? "0" : "1rem",
                                justifyContent: "space-between",
                                marginRight: isMobile ? "0" : "1rem",
                              }}>
                              <img
                                src={bright}
                                height={isMobile ? "15px" : "20px"}
                                style={{ cursor: "pointer", display: "none" }}
                                alt="bright"></img>
                              <img
                                src={time}
                                height={isMobile ? "15px" : "20px"}
                                style={{ cursor: "pointer", display: "none" }}
                                alt="time"></img>
                              <img
                                src={bell}
                                height={isMobile ? "15px" : "20px"}
                                style={{ cursor: "pointer", display: "none" }}
                                alt="bell"></img>
                              {props &&
                                props.route &&
                                (props.route.name === "Payment" ||
                                  props.route.name === "Free Trial") && (
                                  <Link to="/login" className="">
                                    <img
                                      src={logoutimg}
                                      height={isMobile ? "15px" : "30px"}
                                      style={{
                                        cursor: "pointer",
                                        marginTop: "-4px",
                                      }}
                                      alt="logoutimg"
                                      onClick={(e) => signOut(e)}></img>
                                  </Link>
                                )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                cursor: "pointer",
                                alignItems: "center",
                              }}
                              onClick={() => {
                                history.push("/profilePage");
                              }}>
                              {" "}
                              <div
                                style={{
                                  width: "40px",
                                  height:"40px",
                                  minHeight: isMobile ? "30px" : "40px",
                                  borderRadius: "50%",
                                  border: "2px solid #09A84D",
                                  padding: "4px",
                                  backgroundImage: `url('${
                                    (profilePicture && profilePicture) ||
                                    defaultProfilePicture
                                  }')`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                }}></div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  marginLeft: "8px",
                                }}>
                                <span style={{ fontWeight: "bold" }}>
                                  {localStorage.getItem("User") ? (
                                    localStorage.getItem("User")
                                  ) : (
                                    <React.Fragment></React.Fragment>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </div>
            <div style={{ marginBottom: "4.8rem" }}></div>
            {props.route.name === "Profile Page" ||
            props.route.name === "Manage Owners & Entities" ||
            props.route.name === "Setting" ||
            props.route.name === "No Permission" ||
            props.route.name === "Subscription" ||
            props.route.name === "Confirm" ||
            props.route.name === "Accept Invitation" ||
            props.route.name === "Forget Password" ||
            props.route.name === "TrusteeLogin" ||
            props.route.name === "TestForm" ||
            props.route.name === "Otp" ||
            props.route.name === "Register" ||
            props.route.name === "Signup" ||
            props.route.name === "Delegate Access" ||
            props.route.name === "Rewards" ? (
              <SidebarProfile
                profileState={(time) => setProfileChange(time)}
                profileChange={profileChange}
              />
            ) : (
              <Sidebar />
            )}
            <div
              style={{
                backgroundColor: theme === "dark" ? "#161616" : "#F4F7FE",
              }}
              className={`content-page ${shouldHaveNoMargin ? "no-margin-important" : ""}`}
              >
              <nav className="navbar navbar-expand-lg navbar-light bg-light border-bottom justify-content-between d-none">
                <span className="left-side-collapse-icon" onClick={toggleMenu}>
                  <i className="fe-menu"></i>
                  {/* <img src={logo} className="bg-logo" /> */}
                </span>
              </nav>
              <div
                style={{
                  backgroundColor: theme === "dark" ? "#161616" : "#F4F7FE",
                }}
                className="content">
                  {defaultValueName !== "Me" && (
                    <div>
                    <div
                      style={{
                        height: "60px",
                        background: "#FFF",
                        position:'fixed',
                        width: isMobile ? "calc(100% - 210px)": "calc(100% - 275px)",
                        zIndex:"999",
                        top:"5rem",

                      }}>
                      <Row
                        // className="content-page"
                        style={{
                          backgroundColor: theme === "dark" ? "#161616" : "#F4F7FE",
                          minHeight: "60px",
                          padding: isMobile ? "0 80px" : "0 20px",
                          // background: "#FFF",
                          color: "white",
                          background: "#2A3DA3",
                          // backgroundImage: "linear-gradient(to right bottom, #39b54a, #0d723b)",
                        }}
                        type="flex"
                        align="middle"
                        justify="center">
                        <Col xs={24}>
                          <Row type="flex" align="middle">
                            <Col xs={20}>
                              <span style={{ fontSize: "24px" }}>
                                {" "}
                                {localStorage.getItem("User") &&
                                  localStorage.getItem("User")}{" "}
                                is logged in as {defaultValueName}
                              </span>
                            </Col>
                            <Col xs={4}>
                              <Button
                                type="danger"
                                style={{
                                  fontSize: "14px",
                                  cursor: "pointer",
                                  color: "white",
                                  marginRight: isMobile ? "40px" : "0",
                                  borderRadius: "6px",
                                  // paddingRight: "5px",
                                  width: "auto",
                                }}
                                onClick={() => {
                                  setDefaultValueName("Me");
                                  localStorage.removeItem("accessId");
                                  localStorage.removeItem("otp");
                                  if(localStorage.getItem("duplicateRole")){
                                    localStorage.setItem(
                                      "role",
                                      localStorage.getItem("duplicateRole")
                                    );
                                  }
                                  localStorage.removeItem("financialAccess");
                                  dispatch(setAddClientButton(true))
                                  dispatch(setActivated(!activated));
                                  localStorage.removeItem("duplicateRole");
                                  const role = localStorage.getItem("role");
                                  let cleanedRole = role;
                                  // remove wrapping quotes if they exist
                                  if (cleanedRole.startsWith('"') && cleanedRole.endsWith('"')) {
                                    cleanedRole = cleanedRole.slice(1, -1);
                                  }

                                  // normalize
                                  cleanedRole = cleanedRole.trim().toLowerCase();
                                  if (cleanedRole === "trustee" || cleanedRole === "protrustee") {
                                      history.push("/delgateAccess");
                                    } 
                                    else if (
                                      [
                                        "inactive financial advisor",
                                        "active financial advisor",
                                        "financial advisor",
                                        "financial advisor client",
                                      ].includes(cleanedRole)
                                    ) {
                                      history.push("/professional-view");
                                    } 
                                    else {
                                      history.push("/delgateAccess");
                                    }
                                }}>
                                <span className="custom-footer-text">
                                  Cancel Access{" "}
                                  <Icon
                                    type="close-circle"
                                    style={{
                                      marginBottom: "3px",
                                      fontWeight: "800",
                                      fontSize: "18px",
                                    }}
                                  />{" "}
                                </span>
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                    <div style={{ marginTop:"4.1rem" }}></div>
                    </div>
                  )}

                {!(
                  props.route.name === "Login" ||
                  props.route.name === "Free Trial" ||
                  props.route.name === "Page Not Found" ||
                  props.route.name === "Select Dashboard" ||
                  props.route.name === "Setting" ||
                  props.route.name === "No Permission" ||
                  props.route.name === "Subscription" ||
                  props.route.name === "Confirm" ||
                  props.route.name === "Payment" ||
                  props.route.name === "Accept Invitation" ||
                  props.route.name === "Forget Password" ||
                  props.route.name === "TrusteeLogin" ||
                  props.route.name === "TestForm" ||
                  props.route.name === "Otp" ||
                  props.route.name === "Register" ||
                  props.route.name === "Signup" ||
                  props.route.name === "Delegate Access"
                ) && <AiChampion theme={theme} />}

                {/* loadingProgress, progress */}

                {loadingProgress &&
                !(
                  props.route.name === "Login" ||
                  props.route.name === "Free Trial" ||
                  props.route.name === "Page Not Found" ||
                  props.route.name === "Select Dashboard" ||
                  props.route.name === "Setting" ||
                  props.route.name === "No Permission" ||
                  props.route.name === "Subscription" ||
                  props.route.name === "Confirm" ||
                  props.route.name === "Accept Invitation" ||
                  props.route.name === "Forget Password" ||
                  props.route.name === "TrusteeLogin" ||
                  props.route.name === "TestForm" ||
                  props.route.name === "Otp" ||
                  props.route.name === "Register" ||
                  props.route.name === "Signup" ||
                  props.route.name === "Delegate Access"
                ) ? (
                  <PlaidSyncProgressLoader percent={progress} />
                ) : null}

                <Suspense fallback={loading()}>{children}</Suspense>
                {/* </Container> */}
              </div>
            </div>
          </div>
        </React.Fragment>
      }
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.rootReducer.loginUser.loginUserData,
    inventory: state.rootReducer.inventory.inventories,

    // inventory: state.Inventory.inventories,
  };
};
export default connect(mapStateToProps, null)(PageLayout);
